import { mapCountryCodeToDefaultFrequency } from '@seek/salary-data';

import { PayType, type SalaryType } from 'src/types/salaryTypes';
import { CountryCode } from 'src/types/taxonomy';

import { SalaryTypeToPayTypeMap } from '../salary/utils/mappers';

export const getAuNzOnlyCountryCode = (
  countryCode: CountryCode | string,
): CountryCode =>
  countryCode === CountryCode.NewZealand
    ? CountryCode.NewZealand
    : CountryCode.Australia;

export const getCountryCode = (
  countryCode: CountryCode | string,
): CountryCode => {
  switch (countryCode) {
    case CountryCode.NewZealand:
    case CountryCode.Australia:
      return countryCode;
    default:
      return CountryCode.Other;
  }
};

export const isANZCountryCode = (countryCode: string): boolean => {
  const countryCodeEnum: CountryCode =
    countryCode?.toLowerCase() as CountryCode;

  return (
    countryCodeEnum === CountryCode.Australia ||
    countryCodeEnum === CountryCode.NewZealand
  );
};

export const getPayTypeForCountryCode = (country: string): PayType => {
  const defaultFrequency = mapCountryCodeToDefaultFrequency(country);
  return (
    SalaryTypeToPayTypeMap[defaultFrequency as SalaryType] ??
    PayType.ANNUAL_PACKAGE
  );
};
